module.exports = __webpack_public_path__ + "img/zss_xy_q1.0f761cd7.png";